/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Job_Form_Enum_Project_Management17Inputs */

const en_job_form_enum_project_management17 = /** @type {(inputs: Job_Form_Enum_Project_Management17Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Project Management`)
};

const de_job_form_enum_project_management17 = /** @type {(inputs: Job_Form_Enum_Project_Management17Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Projektmanagement`)
};

/**
* | output |
* | --- |
* | "Project Management" |
*
* @param {Job_Form_Enum_Project_Management17Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const job_form_enum_project_management17 = /** @type {((inputs?: Job_Form_Enum_Project_Management17Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Job_Form_Enum_Project_Management17Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_job_form_enum_project_management17(inputs)
	return en_job_form_enum_project_management17(inputs)
});
export { job_form_enum_project_management17 as "job_form_enum_PROJECT_MANAGEMENT" }